// extracted by mini-css-extract-plugin
export default {"left-panel":"DSIUsers_left-panel__Gtbk5","middle-panel":"DSIUsers_middle-panel__3d1TV"};